import styled from 'styled-components';

import { PillText } from '../../../DataTypePill/styled';

export const RichTextEditorCustomMentionPillWrapper = styled.div`
  ${PillText} {
    font-weight: 400;
    font-size: inherit;
    line-height: 35px;
  }

  svg {
    min-width: 16px !important;
    min-height: 16px !important;
  }
`;
